module.exports = __webpack_public_path__ + "static/integrations_icon-018fb153c3a6f6baf2663b3d3085b0bf.png";